import { type JudgeRootCause, type JudgeSummaryResponse } from '../../services/api/judge';
import { cn } from '../../utils/cn';

import { ROOT_CAUSE_LABELS } from './kvalitet-labels';

interface KvalitetRootCauseCardsProps {
  byRootCause: JudgeSummaryResponse['byRootCause'];
  selected: JudgeRootCause | null;
  onSelect: (rootCause: JudgeRootCause) => void;
}

// needs_human hör till nödvändiga överlämningar. Det är ingen brist hos boten och
// står därför utanför defekttotalen och andelarna.
const OUTSIDE_DEFECTS: JudgeRootCause = 'needs_human';

export const KvalitetRootCauseCards = ({
  byRootCause,
  selected,
  onSelect,
}: KvalitetRootCauseCardsProps) => {
  const defects = byRootCause
    .filter((entry) => entry.rootCause !== OUTSIDE_DEFECTS)
    .reduce((sum, entry) => sum + entry.count, 0);

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Rotorsaker</h3>
        <span className="text-xs text-slate-500">
          {defects.toLocaleString('sv-SE')} defekter i perioden
        </span>
      </div>
      <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {byRootCause.map(({ rootCause, count }) => {
          const outside = rootCause === OUTSIDE_DEFECTS;
          const pct = !outside && defects > 0 ? Math.round((count / defects) * 100) : null;
          const active = selected === rootCause;
          return (
            <button
              key={rootCause}
              type="button"
              onClick={() => onSelect(rootCause)}
              aria-pressed={active}
              className={cn(
                'rounded-xl border p-3 text-left shadow-sm transition hover:border-slate-400',
                outside ? 'bg-slate-50 text-slate-400' : 'bg-white',
                active ? 'border-blue-500 ring-2 ring-blue-200' : 'border-slate-200',
              )}
            >
              <div className="text-xs font-semibold text-slate-500">
                {ROOT_CAUSE_LABELS[rootCause]}
              </div>
              <div
                className={cn('text-xl font-bold', outside ? 'text-slate-400' : 'text-slate-900')}
              >
                {count.toLocaleString('sv-SE')}
              </div>
              <div className="text-xs text-slate-400 mt-0.5">
                {outside ? 'Räknas inte som defekt' : `${pct ?? 0} % av defekterna`}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
